export const APP_NAME = 'RAemBurinkaLoansConsolidationCalculator'

export const QUERY_CACHE = {
  PARAMS: APP_NAME + '--params',
  CALC_RESPONSE: APP_NAME + '--calc-response'
}

export const MONTHS_IN_YEAR = 12
export const FIXATION_DEFAULT = 36
export const LOAN_AMOUNT_BOUNDARY_FOR_DURATION = 1000000
export const LOAN_AMOUNT_BOUNDARY_FOR_RESULT = 2500000
export const LOAN_DURATION_HIGHER_MAX = 25

export const trackingKeys = {
  remainingLoanValue: 'Kolik zbývá doplatit',
  remainingLoanValueId: 'remainingLoanValue',
  consolidatedLoansInstallments: 'Kolik měsíčně splácíte',
  consolidatedLoansInstallmentsId: 'consolidatedLoansInstallments',
  additionalMoney: 'Kolik chcete půjčit navíc',
  additionalMoneyId: 'additionalMoney',
  loanDuration: 'Jak dlouho chcete splácet',
  loanDurationId: 'duration'
}
